import { render, staticRenderFns } from "./ContributionSettingSetup.vue?vue&type=template&id=2b98f160&scoped=true&"
import script from "./ContributionSettingSetup.vue?vue&type=script&lang=js&"
export * from "./ContributionSettingSetup.vue?vue&type=script&lang=js&"
import style0 from "./ContributionSettingSetup.vue?vue&type=style&index=0&id=2b98f160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98f160",
  null
  
)

export default component.exports